import { useMutation } from '@tanstack/react-query'
import { postCustomerAgreementCreation } from 'services/CustomerService'
import type { CreateCustomerAgreement } from 'types/customers'

export const useAddCustomerAgreement = () => {
  return useMutation({
    mutationFn: (payload: CreateCustomerAgreement) => postCustomerAgreementCreation(payload),
  })
}
